<template>
  <b-columns is-multiline>
    <b-column class="is-full">
      <section>
        <h1 class="is-size-5 has-margin-bottom-small">Physical properties</h1>
        <div class="is-padded-small">
          <key-value-table :items="tableItems" />
        </div>
      </section>
    </b-column>
  </b-columns>
</template>

<script>
import KeyValueTable from '@/components/structures/KeyValueTable'
import { mapGetters } from 'vuex'

export default {
  components: {
    KeyValueTable
  },
  computed: {
    ...mapGetters(['selectedAgent']),
    tableItems () {
      /* eslint-disable */
      const { lc50, acgih_8h, acgih_stel, idlh } = this.selectedAgent

      return [
        { label: 'LC50', value: lc50, unit: 'ppm' },
        { label: 'ACGIH 8h', value: acgih_8h, unit: 'ppm' },
        { label: 'ACGIH STEL', value: acgih_stel, unit: 'ppm' },
        { label: 'IDLH', value: idlh, unit: 'ppm' },
      ]
    }
  }
}
</script>
